<template>
  <PSBusiNum />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
